/* eslint-disable */
import React from "react";
import Marquee from "react-fast-marquee";

const NotiBar = (props) => {
  let news = props.news;
  return (
    <Marquee>
    <div
      className="justify-content-center"
      style={{
        backgroundColor: "#D3D5D6",
        width: "100%",
        height: "48px",
        display: "flex",
        padding: "10px",
      }}
    >
      {news.map((msg, idx) => {
        return (
          <div key={idx}>
            <a
              href={msg.Link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ width: "300px", overflow: "hidden", color: "#50555B" }}
            >
              {msg.Title}
            </a>
            {idx < 3 && news[idx] && news.length - 1 != idx ? (
              <span className="text-danger mr-2 ml-2">|</span>
            ) : (
              ""
            )}
          </div>
        );
      })}
    </div>
    </Marquee>
  );
};

export default NotiBar;
